<div class="doc-order-fees-container">
  @if (isLoading) {
    <div class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  <form #docOrderFeesForm="ngForm" class="doc-order-fees-form">
    <div class="section-header mb-3">
      <h5>Fee Details</h5>
    </div>
    <div class="row">
      <div class="col-md-4 mb-3">
        <label class="form-label">Underwriter Fee</label>
        <currency-input
          [(ngModel)]="formData.underwriterFee"
          name="underwriterFee"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">In-House Processing Fee</label>
        <currency-input
          [(ngModel)]="formData.inHouseProcessingFee"
          name="inHouseProcessingFee"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Third Party Processing Fee</label>
        <currency-input
          [(ngModel)]="formData.thirdPartyProcessingFee"
          name="thirdPartyProcessingFee"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 mb-3">
        <label class="form-label">Appraisal Fee</label>
        <currency-input
          [(ngModel)]="formData.appraisalFee"
          name="appraisalFee"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Credit Report Fee</label>
        <currency-input
          [(ngModel)]="formData.creditReportFee"
          name="creditReportFee"
          [allowDecimals]="true">
        </currency-input>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Survey Fee</label>
        <currency-input
          [(ngModel)]="formData.surveyFee"
          name="surveyFee"
          [allowDecimals]="true">
        </currency-input>
      </div>
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>Document Order Fees</h5>
    </div>
    <div class="row">
      <div class="col-md-4 mb-3">
        <label class="form-label">Application Fee</label>
        <currency-input
          [(ngModel)]="formData.applicationFee"
          name="applicationFee"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Loan Origination Fee</label>
        <currency-input
          [(ngModel)]="formData.loanOriginationFee"
          name="loanOriginationFee"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Discount Point Fee</label>
        <currency-input
          [(ngModel)]="formData.discountPointFee"
          name="discountPointFee"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 mb-3">
        <label class="form-label">Processor Fee</label>
        <currency-input
          [(ngModel)]="formData.processorFee"
          name="processorFee"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">TX Attorney Fee</label>
        <currency-input
          [(ngModel)]="formData.txAttorneyFee"
          name="txAttorneyFee"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>Compensation &amp; Credits</h5>
    </div>

    <div class="row">
      <div class="col-md-4 mb-3">
        <label class="form-label">Borrower Paid Compensation</label>
        <currency-input
          [(ngModel)]="formData.borrowerPaidCompensation"
          name="borrowerPaidCompensation"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Lender Paid Compensation</label>
        <currency-input
          [(ngModel)]="formData.lenderPaidCompensation"
          name="lenderPaidCompensation"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Origination Credit</label>
        <currency-input
          [(ngModel)]="formData.originationCredit"
          name="originationCredit"
          [allowDecimals]="true"
          [readonly]="true">
        </currency-input>
      </div>
    </div>
  </form>
</div>
